<template>
  <b-modal ref="modal" :cancel-variant="data.cancelVariant || undefined" :header-bg-variant="data.headerBgVariant || undefined" :footer-bg-variant="data.footerBgVariant || undefined" :header-text-variant="data.headerTextVariant || undefined" :size="data.size || 'md'" :centered="data.centered || false" :scrollable="data.scrollable || false" :no-close-on-backdrop="data.noCloseOnBackdrop || false" :no-close-on-esc="data.noCloseOnEsc || false" :title-html="_trans('Assign project')" :ok-only="true" :ok-title="_trans('Ok')" @hide="hide" @hidden="onClose" @shown="onShow" @ok="close(1)">
    <template v-slot:modal-header-close>
      <b-button size="sm" variant="primary" class="ni ni-close" @click="close()"></b-button>
    </template>
    <div class="my-4 d-flex flex-column">
      <circle-loader v-if="!shops || (toShop && !users)" class="mx-auto"></circle-loader>
      <div v-if="shops">
        <h6><span v-text="_trans('Shop:')"></span>&nbsp;<span v-if="toShop" class="text-primary" v-text="toShop.des"></span></h6>
        <shop-search v-model="toShop" :data="shops" :placeholder="_trans('Search shop')">
          <template v-slot:item="props" class="single-item">
            <span v-if="showShopsCod" v-text="props.item.cod"></span>
            <span v-if="showShopsCod">-</span>
            <span v-text="props.item.des"></span>
          </template>
        </shop-search>
      </div>

      <div v-if="toShop && users" class="mt-3">
        <h6><span v-text="_trans('User:')"></span>&nbsp;<span v-if="toUser" class="text-primary" v-text="toUser.des"></span></h6>
        <shop-search v-model="toUser" :data="users" :placeholder="_trans('Search user')">
          <template v-slot:item="props" class="single-item">
            <span v-if="showUsersCod" v-text="props.item.cod"></span>
            <span v-if="showUsersCod">-</span>
            <span v-text="props.item.des"></span>
          </template>
        </shop-search>
      </div>
    </div>
    <template v-slot:modal-footer>
      <b-button variant="info" @click="close(0)" v-text="_trans('Cancel')"></b-button>
      <b-button variant="primary" :disabled="!toShop || !toUser" @click="confirm()" v-text="_trans('Assign')"></b-button>
    </template>
  </b-modal>
</template>
<script>
    import modal from "@dialogs/modal.vue";
    import {NextApiClient} from "@3cad/nextcore";
    import {customImport} from "@/utils";
    import CircleLoader from "@configurator/comp/circleLoader";

    export default {
        mixins: [modal],
        components: {
            CircleLoader,
            shopSearch: () => customImport("comp/shopSearch.vue")
        },
        props: {
            showShopsCod: {type: Boolean, default: true},
            showUsersCod: {type: Boolean, default: true}
        },
        data() {
            return {
                toShop: null,
                toUser: null,
                shops: [],
                users: []
            };
        },
        watch: {
            toShop(newVal) {
                this._toShopWatch(newVal);
            }
        },
        methods: {
            _toShopWatch(newVal) {
                if (newVal) {
                    NextApiClient.com(
                        "projects",
                        "jGetUsers",
                        {shop: newVal.cod},
                        json => {
                            if (!json) throw "Wrong data";

                            this.users = json;
                        },
                        err => {
                            throw err;
                        }
                    );
                }
            },
            onShow() {
                NextApiClient.com(
                    "projects",
                    "jGetShops",
                    {},
                    json => {
                        if (!json) throw "Wrong data";

                        this.shops = json;
                    },
                    err => {
                        throw err;
                    }
                );
            },
            onClose() {
                this.toShop = null;
                this.toUser = null;
                this.shops = [];
                this.users = [];
            },
            confirm() {
                this.response.shop = this.toShop.cod;
                this.response.user = this.toUser.cod;
                this.close(1);
            }
        }
    };
</script>



// WEBPACK FOOTER //
// src/app/dialogs/modalAssign.vue